export const steps = [
        {
          element: ".mission-control",
          intro: "On your dashboard, the MISSION CONTROL panel presents you with all the valuable insights you need to boost your scores and identify your mistakes. The tiles at the bottom of this panel grant you access to details such as: Attendance, Attentiveness, Efficiency, Quiz Average, Time to Test, Course Completion, and Merits!"
        },
        {
          element: ".attendance-tile",
          intro: "Clicking on this tile shows you your attendance stats!"
        },
        {
          element: ".attendance-calendar",
          intro: "Attendance Calendar is more than just a calendar. Not only can you see which days you studied on, but, by hovering over a specific date, you can also see how much you studied each day! <br /><br />The legend for each date of attendance is the following:<br /><br />GREEN:<br />You studied more than hour on that day <br /><br />YELLOW:<br />Your studied less than an hour on that day<br /><br />RED:<br />You didn’t study on that day<br /><br />Go ahead! Hover on one of the dates to try it out."
        },
        {
          element: ".attendance-studied",
          intro: "This statistic shows you the percentage of days you were online IN THE LAST 30 DAYS."
        },
        {
          element: ".attendance-overall",
          intro: "This statistic shows you the percentage of days you were online SINCE YOUR COURSE STARTED."
        },
        {
          element: ".attendance-average",
          intro: "This statistic shows you how many hours you’ve studied each day SINCE YOUR COURSE STARTED."
        },
        {
          element: ".attentiveness-tile",
          intro: "introducing: Attentiveness! We can calculate how attentive you’ve been based on how well you answer lecture questions. You’re asked these questions in the middle of your lecture to ensure active learning! Some questions require you to recall information while others require you to think!"
        },
        {
          element: ".efficiency-tile",
          intro: "You can also track how efficiently you’re finishing your lectures. Here’s the down-low: To get 100% efficiency, you need to finish the lecture in the 'Expected Finish Time'. <br /><br />If you take twice that time, you’ll be 50% efficient. Take half that time, you’ll be more efficient than efficiency itself!"
        },
        {
          element: ".quiz-tile",
          intro: "Using the quiz average, you can correlate your quiz averages with the time you took per lecture. This way, not only can you see which quizzes you scored the best on, but also how long you studied for each of the lectures! <br /><br />Based on this, you can switch up your studying to get the best results."
        },
        {
          element: ".merits-tile",
          intro: "Based on proprietary algorithms, we may or may not give you discounts or special treatment based on this."
        },
        {
          element: ".completion-tile",
          intro: "This is pretty self-explanatory, isn’t it?"
        },
        {
          element: ".test-tile",
          intro: "This ultra-cool feature let’s you keep track of your test so that you can see seconds tick by. #ticktock"
        },
        {
          element: ".flags-panel",
          intro: "This one’s serious. Think of this as the “Uh-oh! I messed up” panel, because here’s where you get cautioned and warned! There are three levels of warnings: Yellow, Orange, and Red. <br /><br />All violations are posted here, and are directly related to your score guarantee (if you have one) and eligibility to use the site further."
        },
        {
          element: ".subject-order",
          intro: "Our super computers analyze your diagnostic test and determine the best order of subjects that you can take! Which means, your course is tailored to your needs. #perfectfit"
        },
        {
          element: ".deadline-button",
          intro: "Before you start a subject, you have to set a deadline for yourself, that you have to abide by. That’s when the timer starts. Here’s the uber cool thing: Whenever you’re behind on your deadline or moving too slow to finish on time, we tell you that you’re behind AND we also tell you how many lectures you have to finish in a day to catch up!",
        }
      ]


// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardUser/tour.js